
export const inventory = {
  productManagement: {
    title: "จัดการเวชภัณฑ์",
    addNew: "เพิ่มรายการยา",
    loading: "กำลังโหลดรายการ...",
    loadingSupabase: "กำลังดึงข้อมูลจาก Supabase...",
    loadingMock: "กำลังใช้ข้อมูลจำลอง...",
    errorTitle: "เกิดข้อผิดพลาด",
    errorMessage: "ไม่สามารถโหลดข้อมูลได้",
    countSupabase: "พบ {{count}} รายการ (ฐานข้อมูลจริง)",
    countMock: "{{count}} รายการ (ข้อมูลจำลอง)",
    deleteConfirm: "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?",
    edit: "แก้ไข",
    delete: "ลบ",
    empty: "ไม่พบรายการยา",
    emptySupabase: "ฐานข้อมูลเชื่อมต่อแล้ว แต่ยังไม่มีรายการ",
    tabs: {
      products: "รายการยา",
      categories: "หมวดหมู่"
    },
    table: {
      name: "ชื่อยา/เวชภัณฑ์",
      sku: "รหัส (SKU)",
      category: "หมวดหมู่",
      price: "ราคา",
      stock: "คงเหลือ",
      status: "สถานะ",
      actions: "จัดการ"
    },
    statusActive: "ใช้งาน",
    statusInactive: "ไม่ใช้งาน"
  },
  pharmacy: {
    title: "ห้องจ่ายยา",
    subtitle: "จ่ายยาและบันทึกข้อมูลรายงาน",
    refresh: "รีเฟรชคิว",
    queue: "คิวรอรับยา",
    searchQueue: "ค้นหาชื่อ หรือ ID...",
    statusApproved: "อนุมัติแล้ว",
    empty: "ไม่มีรายการรอจ่ายยา",
    approvedLabel: "อนุมัติแล้ว",
    posHint: "จำนวนนี้ถูกจองไว้ในโควต้าของผู้ป่วยแล้ว",
    stepsTitle: "ขั้นตอนการจ่ายยา",
    steps: {
      1: "ตรวจสอบตัวตนผู้ป่วย",
      2: "ตรวจสอบรายการยาในใบสั่ง",
      3: "จัดเตรียมยาตามรายการ",
      4: "ติดฉลากยาให้ถูกต้อง",
      5: "อธิบายวิธีการใช้ยาแก่ผู้ป่วย",
      6: "บันทึกการจ่ายยา (สำคัญสำหรับรายงาน)"
    },
    printButton: "ดาวน์โหลด PDF / พิมพ์",
    dispenseButton: "บันทึกการจ่ายยา",
    selectPrompt: "เลือกผู้ป่วยจากรายการเพื่อดูรายละเอียด",
    dispenseModalTitle: "บันทึกการจ่ายยา (ภท.28)",
    modal: {
      warning: "การบันทึกนี้จะถูกส่งไปยังรายงาน ภท.28 ประจำเดือน โปรดตรวจสอบความถูกต้อง",
      productName: "ชื่อสินค้าที่จ่ายจริง",
      quantity: "จำนวนที่จ่าย",
      unit: "หน่วย",
      lot: "เลข Lot / Batch",
      lotPlaceholder: "ระบุหรือไม่ก็ได้",
      note: "หมายเหตุเภสัชกร",
      confirm: "ยืนยันและบันทึก"
    }
  },
  compliance: {
    title: "รายงาน (Compliance)",
    pht27: {
      title: "แบบ ภท.27 (การรับเข้า)",
      subtitle: "รายงานแหล่งที่มาและการเก็บรักษา"
    },
    pht28: {
      title: "แบบ ภท.28 (การจำหน่าย)",
      subtitle: "รายงานการนำไปใช้และจำหน่าย"
    },
    reportHeader27: "แบบ ภท.27: รายงานการรับเข้า",
    reportHeader28: "แบบ ภท.28: รายงานการจำหน่าย",
    month: "ประจำเดือน:",
    export: "ส่งออก Excel",
    print: "พิมพ์รายงาน"
  }
};
